let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eBLgB")).then(() => parcelRequire('1gaUd'));